import { axios, fileService } from '@/utils/request'

const api = {
  uploadFile: '/uploadFile',
  upload: '/upload'
}

export default api

export function uploadFile(data, callback) {
  return axios({
    url: api.uploadFile,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    baseURL: process.env.VUE_APP_OS_BASE_URL,
    //添加上传进度监听事件
    onUploadProgress: e => {
      var completeProgress = (((e.loaded / e.total) * 100) | 0) + '%'
      callback && callback(completeProgress)
    }
  })
}

export function upload(data, callback, params) {
  return fileService({
    url: api.upload,
    method: 'post',
    data,
    params,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: e => {
      // var completeProgress = (((e.loaded / e.total) * 100) | 0) + '%'
      callback && callback(((e.loaded / e.total) * 100) | 0)
    }
  })
}

export function uploadMulti(files = [], callback, params) {
  if (files.length > 0) {
    const formData = new FormData()
    files.forEach(file => {
      formData.append('files', file)
    })
    return upload(formData, callback, params).then(res => {
      const data = res.data
      if (data.code === 200) {
        return Promise.resolve(data.result)
      }
    })
  } else {
    return Promise.resolve([])
  }
}
